import ProductCard from 'common/components/productCard'

import { Product } from '../../api/queries/useGetCategoryProductsQuery'

type Props = {
  product: Product
  onEditDescription: () => void
}

const ProductItem = ({ product, onEditDescription }: Props) => {
  const categoryPath = product.ccn_path ?? []

  return (
    <ProductCard
      id={product.id ?? ''}
      name={product.name ?? ''}
      categoryPath={categoryPath}
      description={product.description}
      onClickEditName={() => onEditDescription()}
    />
  )
}

export default ProductItem
